import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBoxArchive,
  faCircleCheck,
  faCircleXmark,
  faEnvelope,
  faHourglassHalf,
  faLayerGroup,
  faPauseCircle,
  faTableColumns,
  faTriangleExclamation,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

type SideBarItem = {
  label: string;
  route: string;
  icon: IconDefinition;
  activeIcon: string;
  subData?: { label: string; route: string }[];
};

const SideBarData: SideBarItem[] = [
  {
    label: "Dashboard",
    route: "/",
    icon: faTableColumns,
    activeIcon: "",
  },
  {
    label: "Chase List",
    route: "/chaselist",
    icon: faLayerGroup,
    activeIcon: "",
  },
  {
    label: "Awaiting Customer",
    route: "/chase/Awaiting-Customer",
    icon: faHourglassHalf,
    activeIcon: "",
  },
  {
    label: "On-Hold",
    route: "/chase/On-Hold",
    icon: faPauseCircle,
    activeIcon: "",
  },
  {
    label: "Collected",
    route: "/chase/Collected",
    icon: faCircleCheck,
    activeIcon: "",
  },
  {
    label: "Failed",
    route: "/chase/Failed",
    icon: faCircleXmark,
    activeIcon: "",
    subData: [],
  },
  {
    label: "Cancelled",
    route: "/chase/Cancelled",
    icon: faCircleXmark,
    activeIcon: "",
  },
  {
    label: "Pending",
    route: "/chase/Pending-Cancellation",
    icon: faTriangleExclamation,
    activeIcon: "",
  },
  {
    label: "Customer Archives",
    route: "/customer-archives",
    icon: faBoxArchive,
    activeIcon: "",
  },
  {
    label: "My Customers",
    route: "/my-customers",
    icon: faUsers,
    activeIcon: "",
  },
  {
    label: "Agents",
    route: "/agents",
    icon: faUser,
    activeIcon: "",
  },
  {
    label: "Message Templates",
    route: "/message-templates",
    icon: faEnvelope,
    activeIcon: "",
  },
];

export default SideBarData;
